import React from "react";
import "./Topbar.css";

function Topbar() {
  return (
    <div className="top_main_div ">
      <div className="Raive">Welcome to Raive.....!!!!!</div>
    </div>
  );
}

export default Topbar;
